module.exports = __webpack_public_path__ + "assets/img/chatword.496d2a4a.png";